/**
 * app/(marketing)/index.tsx - getabeam.com landing page (web, public).
 *
 * The marketing home for the Beam product. Assembles the hero, feature grid, how-it-works,
 * a pricing teaser, FAQ, and a closing CTA inside the shared <MarketingShell>. All visuals
 * come from src/marketing/* and src/theme - no raw design values here.
 */
import { View } from 'react-native';
import { Text } from '../../src/components/ui';
import { MarketingShell, useMarketingNav } from '../../src/marketing/shell';
import {
  Hero,
  Section,
  Eyebrow,
  FeatureGrid,
  Steps,
  PricingCards,
  FaqList,
  CtaBand,
} from '../../src/marketing/sections';

function LandingBody() {
  const { navigate } = useMarketingNav();
  return (
    <View>
      <Hero onCta={navigate} />

      <Section id="features" tone="paper">
        <FeatureGrid />
      </Section>

      <Section id="how" tone="surface">
        <Steps />
      </Section>

      <Section id="pricing" tone="paper">
        <Eyebrow>Simple pricing</Eyebrow>
        <Text variant="title">Plans that grow with your shop</Text>
        <View style={{ height: 24 }} />
        <PricingCards onSelect={() => navigate('/pricing')} />
      </Section>

      <CtaBand onCta={navigate} />

      <Section tone="surface">
        <FaqList />
      </Section>
    </View>
  );
}

export default function LandingScreen() {
  return (
    <MarketingShell>
      <LandingBody />
    </MarketingShell>
  );
}
